/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_UpdatedInputs */

const en_case_detail_updated = /** @type {(inputs: Case_Detail_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated`)
};

const pt_br2_case_detail_updated = /** @type {(inputs: Case_Detail_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado em`)
};

/**
* | output |
* | --- |
* | "Last updated" |
*
* @param {Case_Detail_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_updated = /** @type {((inputs?: Case_Detail_UpdatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_UpdatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_updated(inputs)
	return pt_br2_case_detail_updated(inputs)
});